import { FC, useEffect, useState } from "react";

import ScreenLoader from "components/ScreenLoader/ScreenLoader";
import Dashboard from "containers/Dashboard/Dashboard";
import { useAccountData, useFetchOffersData } from "modules";
import { useScreenTestId } from "modules/hooks/useScreenTestId";
import { useAppDispatch } from "store";
import { getDashboardData } from "store/actions/dashboard";

import { withTransaction } from "@elastic/apm-rum-react";

const DashboardRoute: FC = () => {
  const dispatch = useAppDispatch();
  const { userHasEstimate, userHasPolicy } = useAccountData();
  const [dataFetched, setDataFetched] = useState(false);
  const { offersFetched } = useFetchOffersData();
  const screenTestId = useScreenTestId();

  useEffect(() => {
    const fetchData = async () => {
      if (userHasEstimate || userHasPolicy) {
        setDataFetched(true);
      }

      await dispatch(getDashboardData());

      setDataFetched(true);
    };

    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid={screenTestId}>
      {!dataFetched || !offersFetched ? <ScreenLoader /> : <Dashboard />}
    </div>
  );
};

export default withTransaction("DashboardRoute", "component")(DashboardRoute);
